import { type ReactNode } from 'react';

import { cx } from '@/lib/cx';
import { Skeleton } from '@/ui/primitives/skeleton';

import { Contador } from './contador';

interface KpiProps {
  rotulo: string;
  /** Número conta quando muda; texto (ex.: moeda) aparece como veio. */
  valor: number | string | null;
  detalhe?: ReactNode;
  icone?: ReactNode;
  destaque?: boolean;
  className?: string;
}

/** Indicador: o número é o protagonista; rótulo em frase curta, sem caixa-alta. */
export function Kpi({ rotulo, valor, detalhe, icone, destaque = false, className }: KpiProps) {
  return (
    <div
      className={cx(
        'grid content-between gap-3 rounded-cartao border p-4',
        destaque ? 'border-marca/30 bg-marca-suave' : 'border-borda bg-superficie',
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2 text-sm text-texto-suave [&_svg]:size-4">
        <span>{rotulo}</span>
        {icone}
      </div>
      <div className="text-2xl font-semibold tracking-tight">
        {valor === null ? (
          <Skeleton className="h-8 w-24" />
        ) : typeof valor === 'number' ? (
          <Contador valor={valor} />
        ) : (
          <span className="tabular">{valor}</span>
        )}
      </div>
      {detalhe && <div className="text-xs text-texto-fraco">{detalhe}</div>}
    </div>
  );
}
